import { Tag } from "./Tag";
import { toMap } from "../../../HA";

export class SVG extends Tag {
    public static readonly SVG_NAMESPACE = "http://www.w3.org/2000/svg";

    public setText(text: string | number): void {
        this.getElement().textContent = String(text);
    }

    // Tag names that must live in the SVG namespace to render correctly.
    // Anything from `<svg>` and its descendants (paths, primitives, gradients,
    // filters, etc.) belongs here. The HTML JSON converter serialises every
    // element as `t:"t"` regardless of namespace, so the dispatcher in
    // HtmlService routes these tag names to this class.
    public static readonly SVG_TAGS: ReadonlySet<string> = new Set<string>([
        "svg", "g", "defs", "use", "symbol",
        "path", "rect", "circle", "ellipse", "line", "polyline", "polygon",
        "marker", "mask", "pattern", "clipPath", "clippath",
        "linearGradient", "lineargradient", "radialGradient", "radialgradient", "stop",
        "text", "tspan", "textPath", "textpath",
        "image", "foreignObject", "foreignobject",
        "title", "desc", "filter",
        "feBlend", "feblend", "feColorMatrix", "fecolormatrix",
        "feComponentTransfer", "fecomponenttransfer",
        "feComposite", "fecomposite", "feConvolveMatrix", "feconvolvematrix",
        "feDiffuseLighting", "fediffuselighting", "feDisplacementMap", "fedisplacementmap",
        "feDistantLight", "fedistantlight", "feDropShadow", "fedropshadow",
        "feFlood", "feflood", "feFuncA", "fefunca", "feFuncB", "fefuncb",
        "feFuncG", "fefuncg", "feFuncR", "fefuncr", "feGaussianBlur", "fegaussianblur",
        "feImage", "feimage", "feMerge", "femerge", "feMergeNode", "femergenode",
        "feMorphology", "femorphology", "feOffset", "feoffset",
        "fePointLight", "fepointlight", "feSpecularLighting", "fespecularlighting",
        "feSpotLight", "fespotlight", "feTile", "fetile", "feTurbulence", "feturbulence",
    ]);

    public getTagName(): string {
        return this.get("_tn") || "svg";
    }

    protected initialize(data: any) {
        if (typeof data === "string") {
            data = toMap({ html: data });
        }
        super.initialize(data);
    }

    protected createSelf() {
        const html = this.get("html");
        const svg = this.get("svg");
        const raw = html ?? svg;
        if (raw) {
            const translated = this.translate(raw);
            if (typeof translated === "string" && translated.trim().startsWith("<svg")) {
                const wrap = document.createElement("div");
                wrap.innerHTML = translated.trim();
                const node = wrap.firstElementChild as Element;
                if (node) {
                    this.setElement(node);
                }
            } else {
                if (!this.get("element")) {
                    this.setElement(document.createElementNS(SVG.SVG_NAMESPACE, this.getTagName()));
                }
                this.getElement().innerHTML = translated;
            }
        } else if (!this.get("element")) {
            this.setElement(document.createElementNS(SVG.SVG_NAMESPACE, this.getTagName()));
        }

        if (this.has("c")) {
            this.createByTypeAndAddAll(this.get("c"), this);
        }
    }
}
